<template>
  <div>
    <div class="flex flex-col justify-center items-center w-full bg-white h-auto rounded-lg">
      
      <div class="flex flex-col text-center justify-center items-center w-full px-10">
        <div class="flex mb-1 justify-center items-center text-center w-full px-10"> 
          <img class="w-5 h-5" :src="require('@/assets/img/spinner.svg')" />
        </div>
        <div>
          <label class="text-gray-700 text-base font-semibold mb-2">
             {{ fileName }}
          </label>
        </div>

        <div class="text-center text-xs font-normal my-2">
          {{ statusText }}
        </div>

        <div class="h-2 bg-gray-200 rounded-full w-full">
          <div 
            class="bg-blue-500 h-2 rounded-full transition-all duration-300"
            :style="{ width: progress + '%' }"
          ></div>
        </div>

        <div class="text-center text-xs font-normal text-gray-500 my-2">
          {{ progress }}%
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    },
    show: Boolean,
    fileName: String,
    disabled: Boolean
  },

  computed: {
    statusText() {
      if (this.progress >= 100) return 'Done'
      return 'Importing...'
    }
  }
}
</script>